{
	"title": "Devi effettuare l'accesso",
	"description": "Per visualizzare questa pagina è necessario aver effettuato l'accesso. Effettua l'accesso. Successivamente verrai reindirizzato alla pagina richiesta.",
	"primaryButtonTitle": "Apri login"
}
